import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { BrandMigration } from "@obg/mat.ui.common";
import { FeatureFlagService } from "@obg/ngx.global";

@Component({
	selector: "obg-m-migration-notification-container",
	styleUrls: ["./migration-notification-container.scss"],
	templateUrl: "./migration-notification-container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MigrationNotificationContainer {
	@HostBinding("class.obg-m-migration-notification-container") hostClass = true;

	@Output() close = new EventEmitter<void>();
	dateWithTime = "";

	constructor(
		private featureFlagService: FeatureFlagService,
		private dialogRef: MatDialogRef<MigrationNotificationContainer>
	) {
		const brandMigration = this.featureFlagService.get<BrandMigration | undefined>(
			"mga_to_tobique_jurisdiction"
		)?.tobiqueMigration;
		if (brandMigration?.tobiqueMigrationDate) {
			this.dateWithTime = brandMigration?.tobiqueMigrationDate?.dateWithTime;
		}
	}

	closeDialog() {
		this.close.emit();
		this.dialogRef.close();
	}
}
